import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  fetchLiveSupportMessages,
  type FetchLiveSupportMessagesParams,
} from '../../api/fetchers/liveSupportMessages/fetcher';

interface FetchLiveSupportMessagesActionParams extends FetchLiveSupportMessagesParams {
  essential?: boolean;
}

export const fetchLiveSupportMessagesAction = createAsyncThunk(
  'fetchMessages/fetchLiveSupportMessages',
  (params: FetchLiveSupportMessagesActionParams) => fetchLiveSupportMessages(params)
);
